import { render, staticRenderFns } from "./PuzzleOptionUngroupModal.vue?vue&type=template&id=7d6ae696&scoped=true&"
import script from "./PuzzleOptionUngroupModal.vue?vue&type=script&lang=js&"
export * from "./PuzzleOptionUngroupModal.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleOptionUngroupModal.vue?vue&type=style&index=0&id=7d6ae696&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6ae696",
  null
  
)

export default component.exports